import(/* webpackMode: "eager" */ "/home/runner/work/xenith-dashboard/xenith-dashboard/apps/operator/src/app/error.tsx");
